import {
  VISITOR_RECORD_REFRESH_MS,
  VISITOR_RECORDED_STORAGE_KEY,
} from './visitor-recorded-storage-key';

interface IVisitorRecord {
  key: string;
  at: number;
}

export function wasVisitorRecordedRecently(key: string): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  try {
    const raw = window.localStorage.getItem(VISITOR_RECORDED_STORAGE_KEY);
    if (!raw) {
      return false;
    }
    const stored = JSON.parse(raw) as IVisitorRecord;
    return stored.key === key && Date.now() - stored.at < VISITOR_RECORD_REFRESH_MS;
  } catch {
    return false;
  }
}
